<template>
  <div class="login-box">
    <img class="bgimg" src="@/assets/images/BG@3x.png" alt="">
    <div class="login-from">
      <div class="login-row">
        <img class="logoimg" src="@/assets/images/shouji@3x.png" alt="">
        <input type="text" v-model="usercode" placeholder="请输入账号">
      </div>
      <div class="login-row">
        <img class="logoimg mm" src="@/assets/images/mima@3x.png" alt="">
        <input type="password" v-model="pazzword" placeholder="请输入密码">
      </div>
      <div class="login-btn" @click="sumbit">登录</div>
      <div class="wjmm" @click="goforget"  >忘记密码</div>

    </div>
  </div>
</template>

<script>
import { ref ,onMounted } from 'vue';
import { useRouter } from 'vue-router'
import request from '@/utils/request'
import { showToast } from 'vant'
export default {
  setup () {
    let router = useRouter()
    let usercode = ref('');  // caiji fuze guanli  
    let pazzword = ref(''); //123456
    
    const sumbit = async () => {
      if (!usercode.value) return showToast('请输入用户名')
      if (!pazzword.value) return showToast('请输入密码')
      let data = {
        usercode: usercode.value,
        pazzword: pazzword.value,
      }
      const loginres = await request({ url: '/login/loginTest', method: "get", params: data })
      if (loginres.errorcode == 0) {
        localStorage.setItem('tz_token', loginres.data.token)
        const res = await request({ url: '/login/loadInfoByToken' })
        if (res.errorcode == 0) {
          localStorage.setItem('yc_userinfo', JSON.stringify(res.data))
          router.push('/index')
          showToast('登录成功')
        }
      } else {
        showToast(loginres.errormsg)
      }
    }
    onMounted(()=>{
      document.title = '南京1号窗口'
    })
    const goforget = ()=>{
      console.log('123');
      router.push('/forget')
    }
    return { usercode, pazzword, sumbit,goforget };
  }
}
</script>

<style lang="less" scoped>
@import url("@/styles/login.less");
</style>